<!-- <button class="btn btn-primary -bg-white -download" (click)="save()">ดาวน์โหลด PDF</button> -->
<!-- {{dateTab4}} -->
<table class="table table--fund -stock table-striped table-hover" width="100%" id="pdfBasket">

    <thead>
        <tr>
            <th width="40%">หุ้น</th>
            <th>ราคาซื้อคืน
                <br class="d-block d-sm-none"> (บาท/หน่วย)
            </th>
            <th>จำนวน (บาท)</th>
        </tr>
    </thead>
    <tbody>
        <tr *ngFor="let item of Tab4PDF">
            <td>{{item.Ticker}}</td>
            <td>{{item.Unit| number}}</td>
            <td>{{item.Result| number: '1.2'}}</td>
        </tr>
    </tbody>
    <tfoot>
        <tr>
            <td></td>
            <td><span class="h6">Total</span></td>
            <td><span class="h2 star">{{Tab4Total | number: '1.2'}}</span></td>
        </tr>
    </tfoot>
</table>